import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import { COLORS } from "../../utilities/Constants"
import { RowMenu } from "./EntretienEcheances"
import { STATUTS, STATUT_KEYS, Pill, tableStyles as ts } from "./entretienUtils"

const EntretienPlans = ({ plans, onEditPlan, menuItems }) => {
	const history = useHistory()
	const [hoverEdit, setHoverEdit] = useState(null)
	return (
		<div style={ts.card}>
			<div style={ts.scroll}>
				<table style={ts.table}>
					<thead>
						<tr style={ts.tr}>
							<th style={ts.th}>Entretien</th>
							<th style={ts.th}>Appliqué à</th>
							<th style={ts.th}>Cycle</th>
							<th style={ts.th}>Modèle d'atelier</th>
							<th style={ts.th}>Véhicules</th>
							<th style={ts.th}>État des échéances</th>
							<th style={ts.th} />
						</tr>
					</thead>
					<tbody>
						{plans.length === 0 && (
							<tr style={ts.tr}>
								<td colSpan={7} style={ts.empty}>
									Aucun plan d'entretien.
								</td>
							</tr>
						)}
						{plans.map((p) => {
							const pills = STATUT_KEYS.filter(
								(k) => p.statuts[k],
							)
							return (
								<tr key={p.id} style={ts.tr}>
									<td style={ts.td}>
										<div style={ts.main}>
											{p.label}
											{p.unique && (
												<span style={ts.tag}>
													Unique
												</span>
											)}
										</div>
										{p.partie_label && (
											<div style={ts.sub}>
												Partie : {p.partie_label}
											</div>
										)}
									</td>
									<td style={ts.td}>
										<div>{p.portee_label}</div>
										<div style={ts.sub}>
											{p.portee_detail}
										</div>
									</td>
									<td style={ts.td}>{p.cycle_label}</td>
									<td style={ts.td}>
										{p.modele ? (
											<button
												type="button"
												style={ts.link}
												onClick={() =>
													history.push(
														`/atelier/modeles/${p.modele.id}`,
													)
												}
											>
												{p.modele.nom}
											</button>
										) : (
											<span style={ts.sub}>—</span>
										)}
									</td>
									<td style={ts.td}>{p.nb_vehicules}</td>
									<td style={ts.td}>
										<div
											style={{
												display: "flex",
												gap: 6,
												flexWrap: "wrap",
											}}
										>
											{pills.length === 0 && (
												<span style={ts.sub}>—</span>
											)}
											{pills.map((k) => (
												<Pill key={k} tone={STATUTS[k]}>
													{p.statuts[k]}{" "}
													{STATUTS[
														k
													].label.toLowerCase()}
												</Pill>
											))}
										</div>
									</td>
									<td
										style={{
											...ts.td,
											textAlign: "right",
											whiteSpace: "nowrap",
										}}
									>
										<button
											type="button"
											style={{
												...ts.smallBtn,
												border: `1px solid ${
													hoverEdit === p.id
														? COLORS.borderStrong
														: COLORS.border
												}`,
											}}
											onMouseEnter={() =>
												setHoverEdit(p.id)
											}
											onMouseLeave={() =>
												setHoverEdit(null)
											}
											onClick={() => onEditPlan(p)}
										>
											Modifier
										</button>
										{menuItems(p).length > 0 && (
											<RowMenu items={menuItems(p)} />
										)}
									</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</div>
	)
}

export default EntretienPlans
